document.addEventListener("DOMContentLoaded", () => {
  const loopMobile = document.querySelector("#openSearchMobile");
  const loopDesktop = document.querySelector("#openSearchDesktop");
  const searchForm = document.querySelector("#searchForm");
  const inputSearchField = document.querySelector("#inputSearchField");
  const closeSearch = document.querySelector("#close-search");
  const mainFrame = document.querySelector("main");

  if (loopMobile && searchForm && closeSearch && mainFrame) {
    loopMobile.addEventListener("click", () => {
      if (searchForm.style.display === "grid") {
        searchForm.style.display = "none";
      } else {
        searchForm.style.display = "grid";

        inputSearchField.focus();
      }
    });

    closeSearch.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      searchForm.style.display = "none";
    });

    mainFrame.addEventListener("click", (event) => {
      searchForm.style.display = "none";
    });
  }

  if (loopDesktop && searchForm && closeSearch && mainFrame) {
    loopDesktop.addEventListener("click", () => {
      if (searchForm.style.display === "grid") {
        searchForm.style.display = "none";
      } else {
        searchForm.style.display = "grid";

        inputSearchField.focus();
      }
    });

    closeSearch.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      searchForm.style.display = "none";
    });

    mainFrame.addEventListener("click", (event) => {
      searchForm.style.display = "none";
    });
  }
});
